// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"09a8f237","5346":"6fd2f0c2","6717":"6fd2f0c2","9971":"c9405b15"}[chunkId] + ".chunk.css";
};